
import React from "react";
import { Helmet } from "react-helmet";
import Layout from "@/components/layout/Layout";
import { ConsultationHero } from "@/components/consultations/ConsultationHero";
import { ExpertProfiles } from "@/components/consultations/ExpertProfiles";
import { HowItWorks } from "@/components/consultations/HowItWorks";
import { ConsultationFAQ } from "@/components/consultations/ConsultationFAQ";
import { BecomeExpertSection } from "@/components/consultations/BecomeExpertSection";
import { SEOHead } from "@/components/seo/SEOHead";

export default function ConsultationsPage() {
  return (
    <Layout>
      <SEOHead 
        title="Expert Consultations Marketplace | Grandpal"
        description="Book one-on-one consultations with verified care placement experts. Browse our marketplace of specialists offering hourly guidance on Fair Deal applications, care assessments, and family support."
        canonicalUrl="/consultations"
      />

      <div className="min-h-screen bg-gray-50">
        <ConsultationHero />
        <ExpertProfiles />
        <HowItWorks />
        <BecomeExpertSection />
        <ConsultationFAQ />
      </div>
    </Layout>
  );
}
